import * as React from 'react';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  tab: string;
  tabHeader: string;
}


function SimpleTabPanelComponent(props: any) {
  const { children, value, index, tab, tabHeader } = props;
  const [style, setStyle] = React.useState({ padding: '15px 10px', height: '100%' })

  React.useEffect(() => {
    if (props.disableMargin ?? false) {
      setStyle({ padding: '0', height: '100%' });
    }
  }, []);

  return (
    <div style={{ borderLeft: '1px #ddd solid', borderRight: '1px #ddd solid', height: '90%' , display: (index == value ? 'block' : 'none') }} className="tab-content" id="nav-tabContent">
      <div style={style} key={`nav-${tabHeader}${index}`} className={`tab-pane fade ${index == 0 ? 'show active' : ''}`} id={`nav-${tabHeader}${index}`} role="tabpanel" aria-labelledby={`nav-${tabHeader}${index}-tab`} >
      {children}
      </div>
    </div>
  );
}

export default SimpleTabPanelComponent;